import { createContext, useState } from "react";

export const SaveGuestDetailsContext = createContext({
  guestDetails: {
    displayName: null,
    email: null,
  },
  setGuestDetails: () => {},
});

export const SaveGuestDetailsProvider = ({ children }) => {
  const [guestDetails, setGuestDetails] = useState(null);
  const value = {
    guestDetails,
    setGuestDetails,
  };
  return (
    <SaveGuestDetailsContext.Provider value={value}>
      {children}
    </SaveGuestDetailsContext.Provider>
  );
};
